<template>
    <TopNav />
    <div class="signup__form mx-auto pt-16">
        <p>
            <input type="text" placeholder="Full Name" v-model="name" />
        </p>
        <p>
            <input type="text" placeholder="Area" v-model="area" />
        </p>
        <p>
            <input type="text" placeholder="City" v-model="city" />
        </p>
        <p>
            <input type="email" placeholder="Email" v-model="email" />
        </p>
        <p>
            <input type="password" placeholder="Password" v-model="password" />
        </p>
        <SolidButton @click="handleSignup" text="Create Account" />
        <router-link to="login">
            <p class="font-gray text-sm text-center mt-2">
                Already have an account?
            </p>
        </router-link>
    </div>
</template>

<script>
import SolidButton from "@/components/SolidButton.vue";
import { ref } from "vue";
import store from "@/store";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { getFirestore, doc, setDoc } from "firebase/firestore";
import TopNav from "@/components/TopNav.vue";
import router from "@/router";

export default {
    name: "SignupView",
    components: {
        SolidButton,
        TopNav,
    },
    setup() {
        const name = ref("");
        const area = ref("");
        const city = ref("");
        const email = ref("");
        const password = ref("");

        const handleSignup = () => {
            if (
                name.value.length != 0 &&
                email.value.length != 0 &&
                password.value.length != 0 &&
                area.value.length != 0 &&
                city.value.length != 0
            ) {
                const auth = getAuth();
                createUserWithEmailAndPassword(
                    auth,
                    email.value,
                    password.value
                )
                    .then((userCredential) => {
                        // Signed in
                        const user = userCredential.user;
                        const db = getFirestore();

                        const current_user = {
                            user_id: user.uid,
                            name: name.value,
                            email: email.value,
                            area: area.value,
                            city: city.value,
                        };

                        // Add to DB
                        try {
                            setDoc(doc(db, "users", user.uid), current_user);
                            console.log("User created and saved in DB");
                        } catch (e) {
                            console.error("Error adding document: ", e);
                        }

                        // Store in state
                        store.dispatch("setCurrentUser", current_user);
                        router.push("/dashboard");
                    })
                    .catch((error) => {
                        const errorCode = error.code;
                        const errorMessage = error.message;
                        // ..
                        console.log(errorCode);
                        console.log(errorMessage);
                    });
            } else {
                alert("Looks like you forgot to fill something!");
            }
        };

        return {
            name,
            email,
            password,
            handleSignup,
            area,
            city,
        };
    },
};
</script>

<style lang="scss">
.signup__form {
    width: 100%;
    max-width: 350px;

    display: flex;
    flex-direction: column;
    align-content: stretch;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    input {
        width: 100%;
        height: 50px;
        margin-bottom: 10px;
        padding: 5px 10px;
        background-color: #fff !important;
        border: 1px solid $light-gray;
        border-radius: 5px;
        outline: none;

        &:focus {
            border: 2px solid $yellow !important;
        }
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px white inset !important;
    }

    button {
        height: 50px !important;
        margin-top: 20px;
    }
}
</style>
